export default __webpack_public_path__ + "static/media/red_info.6b9da512.svg";